"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = onlyOnce;
function onlyOnce(fn) {
    return function () {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/async-eventemitter/~/async/internal/onlyOnce.js
// module id = 351
// module chunks = 0